import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Worksheet, WorksheetItem, WorksheetQuery, WorksheetService, WorksheetType } from '@fgb/core';

@Component({
  selector: 'fgb-worksheet-list',
  templateUrl: './worksheet-list.component.html',
  styleUrls: ['./worksheet-list.component.scss'],
})
export class WorksheetListComponent implements OnInit {
  @Input() hasWorksheetTitle: boolean = true;
  isList: boolean = true;
  isWorksheetItems: boolean = false;
  currentItem: WorksheetItem;
  worksheetId: number;
  worksheetTypes = WorksheetType;
  hasItems: boolean = false;
  worksheets$ = this.worksheetQuery.getWorksheetByRoute(this.router.url.replace('/', ''));
  loading$ = this.worksheetQuery.selectLoading();

  constructor(
    private worksheetService: WorksheetService,
    private worksheetQuery: WorksheetQuery,
    private router: Router
  ) { }

  ngOnInit() {
    if (!this.worksheetQuery.hasRoute(this.router.url.replace('/', ''))) {
      this.worksheetService.fetchWorksheetByRoute(this.router.url.replace('/', '')).toPromise();
    }
    this.worksheets$.subscribe((data) => {
      this.hasItems = this.getActiveWorksheets(data).length > 0;
      if (data.length > 0) {
        const activeItems = this.getActiveItems(data);
        if (activeItems.length > 0) {
          this.isWorksheetItems = false;
          this.currentItem = activeItems[0];
        } else {
          this.isWorksheetItems = true;
        }
        data.map((item) => {
          if (item.WorksheetId) {
            this.worksheetId = item.WorksheetId;
          }
        });
      }
    });
  }

  private getActiveItems(worksheets: Worksheet[]): WorksheetItem[] {
    return worksheets.flatMap((group: Worksheet) =>
      group.Items?.filter((item) => item.WorksheetType === this.worksheetTypes.ProviderVideo && item.Active === 1)
    );
  }

  private getActiveWorksheets(worksheets: Worksheet[]): Worksheet[] {
    return worksheets.filter((group: Worksheet) => group.Active && group.Active === 1);
  }

  selectWorksheetItem(worksheetItem: WorksheetItem) {
    this.currentItem = worksheetItem;
  }

  hasWorksheetType(items: WorksheetItem[], value: number): boolean {
    const filteredItems = items?.filter((item) => item.WorksheetType === value);
    if (filteredItems?.length <= 0 || !filteredItems) {
      return false;
    } else {
      return true;
    }
  }
}
